const countdowns = new Set();
const formatter = new Intl.DateTimeFormat('en-US', {
  timeZone: 'America/Matamoros',
  weekday: 'short',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  hourCycle: 'h23'
});
const weekdays = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
let timer = 0;

function remainingToMonday() {
  const parts = Object.fromEntries(formatter.formatToParts(new Date()).map((part) => [part.type, part.value]));
  const weekday = weekdays[parts.weekday] ?? 1;
  const secondsToday =
    Number(parts.hour || 0) * 3600 +
    Number(parts.minute || 0) * 60 +
    Number(parts.second || 0);

  let daysUntilMonday = (8 - weekday) % 7;
  if (daysUntilMonday === 0) daysUntilMonday = 7;

  const remaining = Math.max(0, daysUntilMonday * 86400 - secondsToday);
  return {
    days: Math.floor(remaining / 86400),
    hours: Math.floor((remaining % 86400) / 3600),
    minutes: Math.floor((remaining % 3600) / 60),
    seconds: remaining % 60
  };
}

function tick() {
  const remaining = remainingToMonday();
  countdowns.forEach((countdown) => countdown.render(remaining));
}

function start() {
  if (timer) return;
  tick();
  timer = window.setInterval(tick, 1000);
}

class SadslothWeeklyCountdown extends HTMLElement {
  connectedCallback() {
    this.nodes = {
      days: this.querySelector('[data-days]'),
      hours: this.querySelector('[data-hours]'),
      minutes: this.querySelector('[data-minutes]'),
      seconds: this.querySelector('[data-seconds]')
    };
    countdowns.add(this);
    start();
  }

  disconnectedCallback() {
    countdowns.delete(this);
    if (!countdowns.size && timer) {
      window.clearInterval(timer);
      timer = 0;
    }
  }

  render({ days, hours, minutes, seconds }) {
    const values = { days, hours, minutes, seconds };
    for (const [key, value] of Object.entries(values)) {
      const next = String(value).padStart(2, '0');
      if (this.nodes?.[key]?.textContent !== next) this.nodes[key].textContent = next;
    }

    const minuteLabel = days + ':' + hours + ':' + minutes;
    if (this.dataset.minuteLabel !== minuteLabel) {
      this.dataset.minuteLabel = minuteLabel;
      this.setAttribute(
        'aria-label',
        'La oferta termina en ' + days + ' días, ' + hours + ' horas y ' + minutes + ' minutos'
      );
    }
  }
}

if (!customElements.get('sadsloth-weekly-countdown')) {
  customElements.define('sadsloth-weekly-countdown', SadslothWeeklyCountdown);
}
